import Vue from 'vue';
import VueRouter, { NavigationGuardNext, Route, RouteConfig } from 'vue-router';
import VueCookies from 'vue-cookies';

import Login from '@/views/login/Login.vue';
import DashBoard from '@/views/dashboard/DashBoard.vue';
import Zone from '@/views/dashboard/Zone.vue';
import SiteConfiguration from '@/views/configuration/SiteConfiguration.vue';
import DeviceListView from '@/views/configuration/DeviceListView.vue';
import MapsView from '@/views/configuration/MapsView.vue';
import Alerts from '@/views/alerts/Alerts.vue';
import Rules from '@/views/rules/Rules.vue';
import Reports from '@/views/reports/Reports.vue';
import GatewayDetail from '@/views/configuration/GatewayDetail.vue';
import NotificationsView from '@/views/notifications/NotificationsView.vue';
import EnergyView from '@/views/energy/Energy.vue';
import Calibration from '@/views/dashboard/Calibration.vue';
import store from '../store';
import initialize from '@/lib/initialize';

Vue.use(VueRouter);
Vue.use(VueCookies);

const routes: Array<RouteConfig> = [
	{ path: '*', redirect: '/dashboard' },
	{
		path: '/login',
		name: 'Login',
		component: Login,
	},
	{
		path: '/dashboard',
		name: 'DashBoard',
		meta: {
			requiresAuth: true,
		},
		component: DashBoard,
	},
	{
		path: '/dashboard/calibration',
		name: 'Calibration',
		meta: {
			requiresAuth: true,
		},
		component: Calibration,
	},
	{
		path: '/dashboard/:zoneId',
		name: 'Zone',
		meta: {
			requiresAuth: true,
		},
		component: Zone,
	},
	{
		path: '/alerts',
		name: 'Alerts',
		meta: {
			requiresAuth: true,
		},
		component: Alerts,
	},
	{
		path: '/site-configuration',
		name: 'SiteConfiguration',
		meta: {
			requiresAuth: true,
		},
		component: SiteConfiguration,
	},
	{
		path: '/site-configuration/:gatewayId',
		name: 'Gateway',
		meta: {
			requiresAuth: true,
		},
		component: GatewayDetail,
	},
	{
		path: '/rules',
		name: 'Rules',
		meta: {
			requiresAuth: true,
		},
		component: Rules,
	},
	{
		path: '/reports',
		name: 'Reports',
		meta: {
			requiresAuth: true,
		},
		component: Reports,
	},
	{
		path: '/devices',
		name: 'Devices',
		meta: {
			requiresAuth: true,
		},
		component: DeviceListView,
	},
	{
		path: '/notifications',
		name: 'Notifications',
		meta: {
			requiresAuth: true,
		},
		component: NotificationsView,
	},
	{
		path: '/maps',
		name: 'Maps',
		meta: {
			requiresAuth: true,
		},
		component: MapsView,
	},
	{
		path: '/energy',
		name: 'Energy',
		meta: {
			requiresAuth: true,
		},
		component: EnergyView,
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

const init = initialize();

function logInComplete(): boolean {
	return (
		store.getters['usermanagement/authentication/getLoggedIn'] &&
		store.getters['tenancy/clients/getSelectedClient'] !== null &&
		store.getters['tenancy/sites/getSelectedSite'] !== null
	);
}

router.beforeEach((to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
	init.then(() => {
		const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

		if (!requiresAuth) {
			if (to.path === '/login' && logInComplete()) {
				next('dashboard');
				return;
			}

			next();
			return;
		}

		if (!logInComplete()) {
			next({ name: 'Login' });
		} else {
			next();
		}
	});
});

export default router;
